import AbstractCommand from "../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import ProgressValue from "../../../../../shared/src/ranj/equalture/platform/ProgressValue";
import GameModel from "../model/GameModel";
import GameStatus from "../model/GameStatus";
import SaveModel from "../model/SaveModel";
import TrackingController from "../model/TrackingController";


export default class StartGameCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveModel} saveModel 
     * @param {GameModel} gameModel 
     * @param {TrackingController} trackingController
     */
    constructor(dispatcher, saveModel, gameModel, trackingController) {
        super(dispatcher);

        this._trackingController = trackingController;

        this.execute = function (event) {
            const saveGame = saveModel.getSaveGame();
            if (saveGame) {
                gameModel.applySnapshot(saveGame);

                const elapsedTime = gameModel.elapsedTime;
                this._trackingController.trackProgress(ProgressValue.RESUMED, elapsedTime);
            }
            if (saveGame && (saveGame.status == GameStatus.FINISH || saveGame.status == GameStatus.END)) {
                this.gotoScreen(SkinKeys.END_SCREEN_SKIN);
            } else {
                this.gotoScreen(SkinKeys.GAME_SCREEN_SKIN);
            }
        };
    };

}